import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-validation-completed',
  templateUrl: './validation-completed.component.html',
  styleUrls: ['./validation-completed.component.scss'],
})
export class ValidationCompletedComponent  implements OnInit {

  constructor(private modalCtrl: ModalController,
    public translate: TranslateService,
  ) { }

  ngOnInit() {}

  goBack(){
    this.modalCtrl.dismiss();
  }
}
